
import { Routes, Route, Navigate } from "react-router-dom";
import AgencyPage from "@/pages/AgencyPage";
import About from "@/pages/About";
import BeginnerAds from "@/pages/BeginnerAds";
import Contact from "@/pages/Contact";
import BusinessOwnersPage from "@/pages/BusinessOwnersPage";
import EcommercePage from "@/pages/EcommercePage";
import FAQs from "@/pages/FAQs";
import Features from "@/pages/Features";
import FreelancerPage from "@/pages/FreelancerPage";
import HowItWorks from "@/pages/HowItWorks";
import SaaSPage from "@/pages/SaaSPage";
import Index from "@/pages/Index";
import LocalBusinessPage from "@/pages/LocalBusinessPage";
import NotFound from "@/pages/NotFound";
import InternationalPage from "@/pages/InternationalPage";
import Pricing from "@/pages/Pricing";
import StormResponse from "@/pages/StormResponse";
import Privacy from "@/pages/Privacy";
import ProAds from "@/pages/ProAds";
import Refund from "@/pages/Refund";
import StartupPage from "@/pages/StartupPage";
import Terms from "@/pages/Terms";
import Checkout from "@/pages/Checkout";
import SuperchargedPage from "@/pages/SuperchargedPage";
import SolopreneurPage from "@/pages/SolopreneurPage";
import KeywordOptimisation from "@/pages/KeywordOptimisation";
import Compare from "@/pages/Compare";
import ValuePropositionGenerator from "@/pages/ValuePropositionGenerator";
import McpLanding from "@/pages/McpLanding";
import DocsMcp from "@/pages/DocsMcp";

// SEO landing pages
import GoogleAdsAutomation from "@/pages/GoogleAdsAutomation";
import AiGoogleAds from "@/pages/AiGoogleAds";
import GoogleAdsAgencySoftware from "@/pages/GoogleAdsAgencySoftware";
import BingAdsLandingPage from "@/pages/BingAdsLandingPage";

// Tier landing pages (renamed: Starter→Solo, Pro→Agency, Agency→Studio)
import SoloTierPage from "@/pages/tiers/StarterTierPage";
import AgencyTierPage from "@/pages/tiers/ProTierPage";
import StudioTierPage from "@/pages/tiers/AgencyTierPage";
import EnterpriseTierPage from "@/pages/tiers/EnterpriseTierPage";

// Geo-specific landing pages
import GermanyPage from "@/pages/geo/GermanyPage";
import FrancePage from "@/pages/geo/FrancePage";
import UKPage from "@/pages/geo/UKPage";
import AustraliaPage from "@/pages/geo/AustraliaPage";
import KeywordOptimierungDE from "@/pages/geo/KeywordOptimierungDE";
import KeywordOptimisationFR from "@/pages/geo/KeywordOptimisationFR";
import KeywordOptimizacionES from "@/pages/geo/KeywordOptimizacionES";
import AutomatisationGoogleAdsFR from "@/pages/geo/AutomatisationGoogleAdsFR";
import GoogleAdsAutomatisierungDE from "@/pages/geo/GoogleAdsAutomatisierungDE";
import AutomatizacionGoogleAdsES from "@/pages/geo/AutomatizacionGoogleAdsES";
import AutomazioneGoogleAdsIT from "@/pages/geo/AutomazioneGoogleAdsIT";

// Blog pages
import BlogIndex from "@/pages/blog";
import BlogPost from "@/pages/blog/[slug]";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Marketing Routes */}
      <Route path="/" element={<Index />} />
      <Route path="/about" element={<About />} />
      <Route path="/agency" element={<AgencyPage />} />
      <Route path="/beginner" element={<BeginnerAds />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/business-owners" element={<BusinessOwnersPage />} />
      <Route path="/ecommerce" element={<EcommercePage />} />
      <Route path="/faqs" element={<FAQs />} />
      <Route path="/features" element={<Features />} />
      <Route path="/freelancer" element={<FreelancerPage />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/local-business" element={<LocalBusinessPage />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/pro" element={<ProAds />} />
      <Route path="/saas" element={<SaaSPage />} />
      <Route path="/startup" element={<StartupPage />} />
      <Route path="/supercharged" element={<SuperchargedPage />} />
      <Route path="/storm-response" element={<StormResponse />} />
      <Route path="/storm-chasers" element={<Navigate to="/storm-response" replace />} />
      <Route path="/storm-chasers/*" element={<Navigate to="/storm-response" replace />} />
      <Route path="/solopreneur" element={<SolopreneurPage />} />
      <Route path="/international" element={<InternationalPage />} />
      <Route path="/keyword-optimisation" element={<KeywordOptimisation />} />
      <Route path="/compare" element={<Compare />} />
      <Route path="/value-proposition-generator" element={<ValuePropositionGenerator />} />

      {/* SEO Landing Pages */}
      <Route path="/google-ads-automation" element={<GoogleAdsAutomation />} />
      <Route path="/ai-google-ads" element={<AiGoogleAds />} />
      <Route path="/google-ads-agency-software" element={<GoogleAdsAgencySoftware />} />
      <Route path="/bing-ads" element={<BingAdsLandingPage />} />
      <Route path="/microsoft-advertising" element={<BingAdsLandingPage />} />

      {/* Geo-specific landing pages */}
      <Route path="/de" element={<GermanyPage />} />
      <Route path="/fr" element={<FrancePage />} />
      <Route path="/uk" element={<UKPage />} />
      <Route path="/au" element={<AustraliaPage />} />
      <Route path="/de/keyword-optimierung" element={<KeywordOptimierungDE />} />
      <Route path="/fr/optimisation-mots-cles" element={<KeywordOptimisationFR />} />
      <Route path="/es/optimizacion-palabras-clave" element={<KeywordOptimizacionES />} />
      
      {/* International SEO Automation Pages */}
      <Route path="/fr/automatisation-google-ads" element={<AutomatisationGoogleAdsFR />} />
      <Route path="/de/google-ads-automatisierung" element={<GoogleAdsAutomatisierungDE />} />
      <Route path="/es/automatizacion-google-ads" element={<AutomatizacionGoogleAdsES />} />
      <Route path="/it/automazione-google-ads" element={<AutomazioneGoogleAdsIT />} />

      {/* Blog Pages */}
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/:slug" element={<BlogPost />} />

      {/* Tier Landing Pages (current tiers) */}
      <Route path="/plans/solo" element={<SoloTierPage />} />
      <Route path="/plans/agency" element={<AgencyTierPage />} />
      <Route path="/plans/studio" element={<StudioTierPage />} />
      <Route path="/plans/enterprise" element={<EnterpriseTierPage />} />

      {/* Legacy tier slug redirects */}
      <Route path="/plans/free" element={<Navigate to="/pricing" replace />} />
      <Route path="/plans/starter" element={<Navigate to="/plans/solo" replace />} />
      <Route path="/plans/pro" element={<Navigate to="/plans/agency" replace />} />
      
      {/* Legal Routes */}
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/refund" element={<Refund />} />
      
      {/* Checkout Route */}
      <Route path="/checkout" element={<Checkout />} />

      {/* MCP product */}
      <Route path="/mcp" element={<McpLanding />} />
      <Route path="/docs/mcp" element={<DocsMcp />} />

      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
